import { PROFILE_GA_CATEGORY } from '../../constants';
import { EVENT_INITIATORS, INTERACTION_TYPES, TARGETS } from '../../../EventTrackingConstants';
import { AnalyticsTypes } from '../../../middleware/google-analytics';

export const ActionTypes = {
    SHOW_INSURANCE_DETAILS: '@@profile/inNetworkInsurances/show_insurance_details',
    HIDE_INSURANCE_DETAILS: '@@profile/inNetworkInsurances/hide_insurance_details',
    TRACK_CLICK_SHOW_IN_NETWORK_DOCTORS: '@@profile/inNetworkInsurances/track_click_show_in_network_doctors',
};

export const showInsuranceDetails = () => ({
    type: ActionTypes.SHOW_INSURANCE_DETAILS,
    meta: {
        analytics: {
            type: AnalyticsTypes.TrackEvent,
            action: 'Click View All Insurances',
            category: PROFILE_GA_CATEGORY,
            tags: [],
            data: {
                Section: TARGETS.PROFILE,
                Component: TARGETS.IN_NETWORK_INSURANCES,
                InteractionType: INTERACTION_TYPES.CLICK,
                Element: TARGETS.VIEW_ALL_ACCEPTED_INSURANCES,
                Initiator: EVENT_INITIATORS.USER,
                EventAction: 'click view all accepted insurances',
            },
        },
    },
});

export const hideInsuranceDetails = () => ({
    type: ActionTypes.HIDE_INSURANCE_DETAILS,
    meta: {
        analytics: {
            type: AnalyticsTypes.TrackEvent,
            action: 'Hide insurance details',
            tags: [],
        },
    },
});

export const trackClickShowInNetworkDoctors = () => ({
    type: ActionTypes.TRACK_CLICK_SHOW_IN_NETWORK_DOCTORS,
    meta: {
        analytics: {
            type: AnalyticsTypes.TrackEvent,
            action: 'Click show in-network doctors',
            data: {
                Section: TARGETS.PROFILE,
                Component: TARGETS.IN_NETWORK_INSURANCES,
                InteractionType: INTERACTION_TYPES.CLICK,
                Element: TARGETS.LINK,
                Initiator: EVENT_INITIATORS.USER,
                EventAction: 'click show in network doctors',
            },
        },
    },
});
